import { useState } from 'react';
import { MainContent } from 'src/spacing';
import Navbar from '../components/Navbar';
import UnifiedLeftNavigation from '../components/UnifiedLeftNavigation';
import BaseLayout from './BaseLayout';
import { Box } from '@mui/material';
import UnlessKeyboard from 'src/components/UnlessKeyboard';

interface Props {
    children: React.ReactNode;
}

export default function DefaultLayout(props: Props) {
    const [navOpen, setNavOpen] = useState(false);
    return (
        <BaseLayout>
            <Box
                id="layout-relative"
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    boxSizing: 'border-box',
                }}
            >
                <UnifiedLeftNavigation open={navOpen} onClose={() => setNavOpen(false)} />
                <UnlessKeyboard>
                    <Navbar onMenuToggle={() => setNavOpen(prev => !prev)} />
                </UnlessKeyboard>
                <MainContent>
                    <>{props.children}</>
                </MainContent>
            </Box>
        </BaseLayout>
    );
}
